import { Locales } from '@/constants/Locales';
// English is imported statically because i18n installs with englishLocaleMessage() before any await.
import enClientDeployOverride from '@/build/active/locales/en.override.yaml';

const CLIENT_DEPLOY_ASYNC_OVERRIDE_LOADERS: Partial<
  Record<Locales, () => Promise<{ default: Record<string, unknown> }>>
> = {
  [Locales.FRENCH]: () => import('@/build/active/locales/fr.override.yaml'),
  [Locales.JAPANESE]: () => import('@/build/active/locales/ja.override.yaml'),
  [Locales.CHINESE_SIMPLIFIED]: () => import('@/build/active/locales/zh-Hans.override.yaml'),
  [Locales.CHINESE_TRADITIONAL]: () => import('@/build/active/locales/zh-Hant.override.yaml'),
};

/** Used from {@link englishLocaleMessage} at plugin install. */
export function getEnglishClientDeployLocaleOverride(): Record<string, unknown> {
  return enClientDeployOverride;
}

export async function getClientDeployLocaleOverride(locale: Locales): Promise<Record<string, unknown>> {
  if (locale === Locales.ENGLISH) {
    return enClientDeployOverride;
  }

  const loader = CLIENT_DEPLOY_ASYNC_OVERRIDE_LOADERS[locale];
  if (!loader) {
    return {};
  }

  const mod = await loader();
  return mod.default;
}
